import PropTypes from "prop-types";
import * as React from "react";
import { Dialog } from "../../themeV2";
import s from "./VideoPlaybackDialog.module.css";

function VideoPlaybackDialog({ src, title, description, videoLabel, onClose }) {
  return (
    <Dialog.Root
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <Dialog.Popup size="lg">
        <Dialog.Close />
        <Dialog.Title>{title}</Dialog.Title>
        {description && <Dialog.Description>{description}</Dialog.Description>}
        <Dialog.Body>
          <video
            className={s.video}
            src={src}
            aria-label={videoLabel}
            controls
            autoPlay
            playsInline
            preload="metadata"
          />
        </Dialog.Body>
      </Dialog.Popup>
    </Dialog.Root>
  );
}

VideoPlaybackDialog.propTypes = {
  src: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node,
  videoLabel: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default React.memo(VideoPlaybackDialog);
